/**
 * @description: 账单打印机设置
 * @author: hwx
 */
<template>
	<div class="actprt-manage-wrap">
		<h1>账单打印机设置</h1>
		<div class="actprt-list">
			<div class="row">
				<label class="col-md-1 list-label-2">门店:</label>
				<div class="col-md-4 ct-col">
					<select class="form-control" ref="actprt_shop"></select>
				</div>
				<button type="button" class="btn btn-flat btn-small btn-orange" @click="actprtQuery">查询</button>
				<button type="button" class="btn btn-flat btn-small btn-orange" @click="addActprt">添加打印机</button>
			</div>
			<div class="table-responsive">
				<table class="table table-bordered table-hover" data-pagination="true" ref="actprt_list"></table>
			</div>
		</div>
		<div class="actprt-edit" ref="actprt_edit">
			<div class="row">
				<label class="col-md-3">门店：</label>
				<div class="col-md-9 ct-col">
					<select class="form-control" ref="edit_shop"></select>
				</div>
			</div>
			<div class="row">
				<label class="col-md-3">打印机：</label>
				<div class="col-md-9">
					<input class="form-control input-readonly" placeholder="请选择打印机" v-model="edit_printer_txt" ref="edit_printer_txt" @click="openPrinter($event)" readonly>
					<span class="selection-clear" @click="clearInput">×</span>
					<span class="span-arrow" role="presentation"><b></b></span>
				</div>
			</div>
			<div class="row">
				<el-checkbox v-model="is_default" label="默认打印机" true-label="1" false-label="-1"></el-checkbox>
				<span class="red-tip">（勾选后，其他未设置打印机的门店，制作账单打印将从默认打印机打印）</span>
			</div>
		</div>
		<!-- 打印机列表 -->
		<div class="print-sel-wrap" ref="print_sel_wrap">
			<ul>
				<li>
					<input type="checkbox" id="pall" v-model='print_sel_all' @click="printSelAll">
					<label for="pall">全部</label>
				</li>
				<li v-for="item in print_sel_arr">
					<input type="checkbox" :id="item.printer_key" v-model="print_sel_item" :value="item.printer_key">
					<label :for="item.printer_key">{{item.printer_name}}</label>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
	import Vue from 'vue';
	export default {
		name: 'order_manage',
		data() {
			return {
				actprt_list_total: '',
				edit_printer_txt: '',
				print_sel_all: false,
				print_sel_all_c: false,
				print_sel_arr: [],
				print_sel_item: [],
				is_default: '-1',
			}
		},
		watch: {
			edit_printer_txt: {
				handler: function(val, oldval) {
					if(val != "") {
						$(this.$refs.edit_printer_txt).parent().find('.selection-clear').show();
					} else {
						$(this.$refs.edit_printer_txt).parent().find('.selection-clear').hide();
					}
				},
				deep: true
			},
			print_sel_item: {
				handler: function(val, oldVal) {
					if(this.print_sel_item.length >= this.print_sel_arr.length) {
						this.print_sel_all = true;
						this.print_sel_all_c = true;
					} else {
						this.print_sel_all = false;
						this.print_sel_all_c = false;
					}
				},
				deep: true
			},
		},
		mounted: function() {
			this.getShopData();
		},
		methods: {
			// 获取门店数据
			getShopData: function() {
				let _this = this;

				let datas = {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {
							
						}
					},
					"comment": ""
				};
				let datas2 = JSON.stringify(datas);
				$.ajax({
					type: "post",
					dataType: "json",
					url: Vue.ctUrl + "PublicData/api_getShopListByPurview",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
					data: {
						json: datas2
					},
					success: function(data) {
						if(data.response.result_code == "true") {
							let arr = [];
							$.each(data.response.result, function(k, v) {
								arr.push({ id: v.id, text: v.name });
							});
							arr.shift();
							$(_this.$refs.actprt_shop).select2({
								data: arr,
								language: "zh-CN",
								width: '100%'
							});
							_this.initTable();

							$(_this.$refs.edit_shop).select2({
								data: arr,
								language: "zh-CN",
								width: '100%'
							}).on("select2:select", function(e) {
								_this.getPrinterData();
								_this.clearInput();
							});
							_this.getPrinterData();
						} else {
							Vue.timeoutfun(data.response.result_status,_this);
							layer.msg(data.response.data.error_msg);
						}
					},
					error: function(err) {
						layer.msg("网络错误");
					}
				});
			},
			// 获取打印机
			getPrinterData: function() {
				let _this = this;

				let datas = {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {
							"page": 0,
							"page_size": 0,
							"shop_id": $(_this.$refs.edit_shop).val(),
							"status": 1
						}
					},
					"comment": ""
				};
				let datas2 = JSON.stringify(datas);
				$.ajax({
					type: "post",
					dataType: "json",
					url: Vue.ctUrl + "Printer/getPrinterList",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
					data: {
						json: datas2
					},
					success: function(data) {
						if(data.response.result_code == "true") {
							_this.print_sel_arr = data.response.result.rows;
						} else {
							Vue.timeoutfun(data.response.result_status,_this);
							layer.msg(data.response.data.error_msg);
						}
					},
					error: function(err) {
						layer.msg("网络错误");
					}
				});
			},
			// 初始化列表
			initTable: function() {
				let _this = this;
				$(_this.$refs.actprt_list).bootstrapTable('destroy');
				$(_this.$refs.actprt_list).bootstrapTable({
					pageNumber: 1,
					pageSize: 15,
					pageList: [],
					pagination: true,
					ajax: function(params) {
						_this.getActprtList(params);
					},
					sidePagination: "server",
					columns: [{
						field: "shop_name",
						title: "门店",
						width: "10%"
					}, {
						field: "printer_key_name",
						title: "打印机名称",
						width: "10%"
					}, {
						title: "操作",
						width: "10%",
						events: {
							'click .modify': function(e, value, row, index) {
								$(_this.$refs.edit_shop).val(row.shop_id).trigger('change');
								_this.edit_printer_txt = row.printer_key_name;
								_this.print_sel_item = row.printer_key;
								_this.is_default = row.is_default;
								_this.editActprt('修改打印机', '2', row.id);
							}
						},
						formatter: function(value, row, index) {
							return '<span class="text-blue modify">修改</span>'
						}
					}],
				});
			},
			getActprtList: function(params) {
				let _this = this,
					pageNumber = 1;
				if(params != "" && params.data.offset != 0) {
					pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
				}
				let datas = {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {
							"page": pageNumber,
							"page_size": params.data.limit,
							"shop_id": $(_this.$refs.actprt_shop).val()
						}
					},
					"comment": ""
				};
				let datas2 = JSON.stringify(datas);
				$.ajax({
					type: "post",
					dataType: "json",
					url: Vue.ctUrl + "FalsifyBill/getPrinterList",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
					data: {
						json: datas2
					},
					success: function(data) {
						if(data.response.result_code == "true") {
							if(pageNumber == '1') {
								_this.actprt_list_total = data.response.result.count;
							}
							params.success({
								total: _this.actprt_list_total,
								rows: data.response.result.data
							});
						} else {
							Vue.timeoutfun(data.response.result_status, _this);
							layer.msg(data.response.error_msg);
							params.success({
								total: 0,
								rows: 0
							});
						}
					},
					error: function(err) {
						layer.msg("出错啦");
					}
				});
			},
			// 查询
			actprtQuery: function() {
				this.initTable();
			},
			// 打开打印机选项
			openPrinter: function() {
				let _this = this;

				let print_sel_item_c = _this.print_sel_item;
				layer.confirm('', {
					skin: 'add_goods-alert',
					type: 1,
					btn: ['确定', '取消'],
					title: ['选择打印机', true],
					area: ['560px', ''],
					content: $(_this.$refs.print_sel_wrap),
					offset: '100px',
					cancel: function() {
						// 右上角关闭
						if(_this.edit_printer_txt != "") {
							_this.print_sel_item = print_sel_item_c;
							return;
						}
						_this.print_sel_item = [];
					}
				}, function() {
					let texts = [];
					_this.print_sel_arr.forEach(function(item) {
						_this.print_sel_item.forEach(function(item2) {
							if(item.printer_key == item2) {
								texts.push(item.printer_name);
							}
						});
					});
					_this.edit_printer_txt = texts.join(",");
					layer.close(layer.index);
				}, function() {
					if(_this.edit_printer_txt != "") {
						_this.print_sel_item = print_sel_item_c;
						return;
					}
					_this.print_sel_item = [];
				});
			},
			// 全选
			printSelAll: function() {
				let _this = this;

				_this.print_sel_all = _this.print_sel_all_c;
				if(!_this.print_sel_all) { // 实现全选
					_this.print_sel_item = [];
					_this.print_sel_arr.forEach(function(item) {
						_this.print_sel_item.push(item.printer_key);
					});
				} else { // 实现反选
					_this.print_sel_item = [];
				}
			},
			// 清空
			clearInput: function() {
				this.edit_printer_txt = '';
				this.print_sel_item = [];
			},
			// 添加打印机
			addActprt: function() {
				$(this.$refs.edit_shop).val('').trigger('change');
				this.edit_printer_txt = '';
				this.print_sel_item = [];
				this.is_default = '-1'
				this.editActprt('添加打印机', '1');
			},
			editActprt: function(name, type, id) {
				let _this = this;
				layer.confirm('', {
					skin: 'add_goods-alert',
					type: 1,
					btn: ['确定', '取消'],
					title: [name, true],
					area: ['660px', ''],
					content: $(_this.$refs.actprt_edit),
					offset: '100px'
				}, function() {
					let datas = {
						"header": Vue.request_header,
						"request": {
							"version": Vue.version,
							"param": {
								"shop_id": $(_this.$refs.edit_shop).val(),
								"printer_key": _this.print_sel_item,
								"id": id || '',
								"is_default": _this.is_default // 1：默认打印机，-1：否
							}
						},
						"comment": ""
					};
					if(type == '2') {
						datas.request.param.id = id;
					}
					let datas2 = JSON.stringify(datas);
					$.ajax({
						type: "post",
						dataType: "json",
						url: Vue.ctUrl + "FalsifyBill/setPriinter",
						crossDomain: true,
						xhrFields: {
							withCredentials: true
						},
						data: {
							json: datas2
						},
						success: function(data) {
							if(data.response.result_code == "true") {
								layer.closeAll();
								layer.msg(data.response.error_msg);
								$(_this.$refs.actprt_list).bootstrapTable('refresh');
							} else {
								Vue.timeoutfun(data.response.result_status, _this);
								layer.msg(data.response.error_msg);
							}
						},
						error: function(err) {
							layer.msg("出错啦");
						}
					});
				});
			},
		}

	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
	.actprt-manage-wrap {
		.actprt-list {
			button {
				margin: 0 0 0 30px;
			}
		}
		.actprt-edit {
			display: none;
			width: 70%;
			margin: 20px auto;
			label {
				padding: 0;
				line-height: 32px;
				color: #5e5e5e;
				font-size: 14px;
				text-align: right;
				font-weight: normal;
			}
			.row {
				margin: 0 0 20px;
				&:last-child {
					margin-left: 50px;
				}
			}
			.red-tip {
				color: red;
			}
		}
		.print-sel-wrap {
			display: none;
			padding: 30px 20px;
			font-size: 14px;
			ul {
				width: 27%;
				margin: 0 auto;
				li {
					margin: 0 0 15px;
				}
				label {
					margin: 0 0 0 6px;
				}
			}
		}
	}
</style>